/* VINDRAX theme JS (Vindrax SE v1). No external deps. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

  /* ---------- prices config ---------- */
  var PR = {};
  try { PR = JSON.parse($('#vx-prices').textContent); } catch (e) { PR = { products: {}, ph: {} }; }
  function cfg(handle) {
    var c = (PR.products || {})[handle];
    if (c && c.same_as) c = PR.products[c.same_as];
    return c || null;
  }
  function money(c) {
    if (typeof c === 'string') return c;
    var kr = Math.round((c || 0) / 100);
    return kr.toLocaleString('sv-SE').replace(/ /g, ' ') + ' kr';
  }
  window.VX = { money: money, cfg: cfg, PR: PR };
  function fillPh(scope) {
    $$('[data-vxph]', scope).forEach(function (el) {
      var k = el.getAttribute('data-vxph');
      if (k === 'SHIPPING_DAYS_SE') { el.textContent = PR.shipping_days || el.textContent; return; }
      if (PR.ph && PR.ph[k] != null) el.textContent = money(PR.ph[k]);
    });
  }

  /* ---------- overlays ---------- */
  var ov = $('.vx-ov');
  function openPanel(p) { if (!p) return; closeAll(); p.classList.add('is-open'); if (ov) ov.classList.add('is-open'); document.body.classList.add('vx-lock'); p.setAttribute('aria-hidden', 'false'); }
  function closeAll() { $$('.vx-menu,.vx-cart,.vx-search').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); }); if (ov) ov.classList.remove('is-open'); document.body.classList.remove('vx-lock'); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-vx-open],[data-vx-close]');
    if (!t) { if (e.target === ov) closeAll(); return; }
    e.preventDefault();
    if (t.hasAttribute('data-vx-close')) return closeAll();
    var w = t.getAttribute('data-vx-open');
    if (w === 'cart') return openCart();
    openPanel($('.vx-' + w));
    if (w === 'search') { var i = $('.vx-search input'); if (i) setTimeout(function () { i.focus(); }, 50); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = $('.vx-toast'); if (!t) { t = document.createElement('div'); t.className = 'vx-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ---------- cart ---------- */
  var cartEl = $('.vx-cart');
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; if (u.indexOf('/assets/') > -1 || u.indexOf('width=') > -1) return u; return u.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2'); }
  function setCount(n) { $$('[data-vx-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(c) {
    setCount(c.item_count);
    if (!cartEl) return c;
    var body = $('.vx-cart__body', cartEl), foot = $('.vx-cart__foot', cartEl), ship = $('.vx-cart__ship', cartEl);
    var min = PR.free_ship_min || 0, tot = c.total_price;
    if (ship) {
      if (min) {
        var left = Math.max(0, min - tot), pct = Math.min(100, Math.round(tot / min * 100));
        ship.innerHTML = (left > 0 ? 'Handla för <strong>' + money(left) + '</strong> till för FRI frakt!' : 'Grattis, du har fri frakt!') + '<div class="vx-cart__prog"><b style="width:' + pct + '%"></b></div>';
        ship.hidden = c.item_count === 0;
      } else ship.hidden = true;
    }
    if (!c.item_count) {
      body.innerHTML = '<div class="vx-cart__empty"><p>Din varukorg är tom.</p><a class="vx-btn vx-btn--primary" href="' + root + 'collections/all">Handla allt <span class="vx-arrow">→</span></a></div>';
      if (foot) foot.hidden = true;
      return c;
    }
    var h = '';
    c.items.forEach(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(', ');
      var save = it.original_line_price - it.final_line_price;
      h += '<div class="vx-li" data-line="' + (i + 1) + '">' +
        '<a class="vx-li__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="84" height="105">' : '') + '</a>' +
        '<div><a class="vx-li__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (opts ? '<div class="vx-li__v">' + opts + '</div>' : '') +
        (it.final_line_price === 0 ? '<div class="vx-li__p"><span class="vx-price vx-price--sale" style="font-size:14px">GRATIS</span> <span style="font-size:12.5px;color:var(--vx-brown-3)">(värde ' + money(((cfg(it.handle) || {}).compare || 0) * it.quantity) + ')</span></div>' : '<div class="vx-li__p">' + (save > 0 ? '<span class="vx-price--compare" style="margin:0 6px 0 0">' + money(it.original_line_price) + '</span>' : '') + '<span class="vx-price" style="font-size:14px">' + money(it.final_line_price) + '</span>' + (save > 0 ? ' <span class="vx-li__save">(Spara ' + money(save) + ')</span>' : '') + '</div>') +
        '<div class="vx-qty"><button type="button" data-q="-1" aria-label="Minska">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Antal"><button type="button" data-q="1" aria-label="Öka">+</button></div>' +
        (it.line_level_discount_allocations && it.line_level_discount_allocations.length ? '<div><span class="vx-li__tag">Paketrabatt</span></div>' : '') +
        '</div><button class="vx-li__rm" type="button" aria-label="Ta bort"><svg viewBox="0 0 24 24"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button></div>';
    });
    var up = $('#vx-upsells');
    if (up) {
      var inCart = c.items.map(function (x) { return x.handle; });
      var ups = []; try { ups = JSON.parse(up.textContent); } catch (e) { }
      ups = ups.filter(function (p) { return inCart.indexOf(p.handle) < 0 && p.variants.length; });
      if (ups.length) {
        h += '<div class="vx-up"><h4>Komplettera din rutin</h4><div class="vx-up__row">';
        ups.forEach(function (p) {
          h += '<div class="vx-up__card"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"><div><div class="vx-up__t">' + esc(p.title) + '</div><div class="vx-price" style="font-size:14px">' + money(p.price) + '</div>' +
            (p.variants.length > 1 ? '<select aria-label="Variant">' + p.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>'; }).join('') + '</select>' : '<input type="hidden" value="' + p.variants[0].id + '">') +
            '<button class="vx-btn vx-btn--primary" type="button" data-vx-upadd>Lägg till</button></div></div>';
        });
        h += '</div></div>';
      }
    }
    body.innerHTML = h;
    if (foot) {
      foot.hidden = false;
      $$('[data-vx-total]', foot).forEach(function (el) { el.textContent = money(c.total_price); });
    }
    return c;
  }
  function refresh() { return fetchCart().then(renderCart); }
  function openCart() { refresh().catch(function () { }); openPanel(cartEl); }
  function change(line, q) { return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) }).then(function (r) { return r.json(); }).then(renderCart); }
  function add(items) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fel'); return j; }); })
      .then(function () { return refresh(); })
      .then(function () { if (cartEl) openPanel(cartEl); else location.href = root + 'cart'; });
  }
  window.VX.add = add; window.VX.refresh = refresh;
  if (cartEl) {
    cartEl.addEventListener('click', function (e) {
      var li = e.target.closest('.vx-li');
      if (li) {
        var line = +li.getAttribute('data-line'), inp = $('input', li);
        if (e.target.closest('[data-q]')) change(line, Math.max(0, +inp.value + +e.target.closest('[data-q]').getAttribute('data-q')));
        if (e.target.closest('.vx-li__rm')) change(line, 0);
      }
      var u = e.target.closest('[data-vx-upadd]');
      if (u) { var card = u.closest('.vx-up__card'), s = $('select,input', card); u.classList.add('is-loading'); add([{ id: +s.value, quantity: 1 }]).catch(function (er) { toast(er.message); }).then(function () { u.classList.remove('is-loading'); }); }
    });
    cartEl.addEventListener('change', function (e) { var li = e.target.closest('.vx-li'); if (li && e.target.matches('input')) change(+li.getAttribute('data-line'), Math.max(0, +e.target.value)); });
  }
  fetchCart().then(function (c) { setCount(c.item_count); }).catch(function () { });

  /* ---------- quick add on cards ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vx-qa]'); if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-vx-qa');
    if (!id) { location.href = b.getAttribute('data-url'); return; }
    b.classList.add('is-loading');
    add([{ id: +id, quantity: 1 }]).catch(function (er) { toast(er.message); }).then(function () { b.classList.remove('is-loading'); });
  });

  /* ---------- product forms ---------- */
  function initProduct(el) {
    var data; try { data = JSON.parse($('script[data-vx-pjson]', el).textContent); } catch (e) { return; }
    var handle = el.getAttribute('data-handle'), C = cfg(handle), giftId = +(el.getAttribute('data-gift-variant') || 0);
    var fb = data.fallback || {}, ci = (data.options || []).indexOf('Färg');
    data.variants.forEach(function (v) { if (!v.image && ci > -1 && fb[v.options[ci]]) v.image = fb[v.options[ci]]; });
    var opts = data.options || [], realOpts = opts.filter(function (o) { return o !== 'Title'; });
    var atc = $('[data-vx-atc]', el), atcLbl = atc ? $('.vx-atc__lbl', atc) : null, msg = $('.vx-pdp__msg', el);
    function findVariant(vals) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; }); })[0];
    }
    function firstAvail() { return data.variants.filter(function (v) { return v.available; })[0] || data.variants[0]; }
    var offers = $('.vx-offers', el);
    var state = { tier: null, variant: data.variants.filter(function (v) { return v.id == el.getAttribute('data-variant'); })[0] || firstAvail() };

    function label(t) {
      var tot = t.total, each = Math.round(t.total / t.q / 100) * 100, save = t.compare - t.total;
      return { each: money(each), save: money(save), total: money(tot) };
    }
    function pickerRow(i) {
      var fv = firstAvail(), h = '<div class="vx-pick" style="--n:' + realOpts.length + '"><span class="vx-pick__n">' + (i + 1) + '</span>';
      opts.forEach(function (o, oi) {
        if (o === 'Title') return;
        var vals = []; data.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
        h += '<select data-oi="' + oi + '" aria-label="' + esc(o) + ' ' + (i + 1) + '">' + vals.map(function (v) { return '<option' + (v === fv.options[oi] ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') + '</select>';
      });
      return h + '</div>';
    }
    function buildOffers() {
      if (!offers || !C || !C.tiers) return;
      var list = $('.vx-offers__list', offers), h = '';
      C.tiers.forEach(function (t, i) {
        var L = label(t), name = (t.name || '').replace('{save}', L.save).replace('{each}', L.each), sub = (t.sub || '').replace('{each}', L.each).replace('{save}', L.save), chip = (t.chip || '').replace('{each}', L.each);
        h += '<label class="vx-offer" data-tier="' + i + '"><input type="radio" name="vx-tier-' + handle + '" value="' + i + '">' +
          (t.flag ? '<span class="vx-offer__flag">' + esc(t.flag) + '</span>' : '') +
          '<span class="vx-offer__row"><span class="vx-offer__check"><svg viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg></span>' +
          '<span><span class="vx-offer__name">' + esc(name) + '</span>' + (chip ? '<br><span class="vx-offer__chip">' + esc(chip) + '</span>' : '') + (sub ? '<span class="vx-offer__sub" style="display:block">' + esc(sub) + '</span>' : '') + '</span>' +
          '<span class="vx-offer__price"><span class="vx-price' + (t.compare > t.total ? ' vx-price--sale' : '') + '">' + L.total + '</span>' + (t.compare > t.total ? '<span class="vx-price--compare">' + money(t.compare) + '</span>' : '') + '</span></span>' +
          (t.perk ? '<span class="vx-offer__perks"><span class="vx-offer__perk"><svg viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg>' + esc(t.perk) + '</span></span>' : '');
        if (C.mode !== 'variant' && realOpts.length) {
          h += '<span class="vx-offer__pickers"><small>' + realOpts.map(esc).join(', ') + '</small>';
          for (var k = 0; k < t.q; k++) h += pickerRow(k);
          h += '</span>';
        }
        if (t.gift) h += '<span class="vx-offer__gift"><svg viewBox="0 0 24 24"><path d="M3 11h18v10H3zM2 7h20v4H2zM12 7v14M12 7c-2-4-6-4-6-1s6 1 6 1zm0 0c2-4 6-4 6-1s-6 1-6 1z"/></svg>' + esc(t.gift_label || 'Gratis present') + '</span>';
        h += '</label>';
      });
      list.innerHTML = h;
      var t0 = $('.vx-offers__title', offers); if (t0 && C.title) t0.textContent = C.title;
      list.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        var lab = e.target.closest('.vx-offer'); if (lab) selectTier(+lab.getAttribute('data-tier'));
      });
      list.addEventListener('change', function (e) { if (e.target.matches('select')) { syncThumbs(e.target.closest('.vx-pick')); updateAtc(); } });
      selectTier((C.default || 1) - 1);
      $$('.vx-pick', list).forEach(syncThumbs);
    }
    function syncThumbs(row) {
      if (!row) return;
      var vals = opts.map(function () { return null; });
      $$('select', row).forEach(function (s) { vals[+s.getAttribute('data-oi')] = s.value; });
      var v = findVariant(vals), n = $('.vx-pick__n', row);
      if (v && v.image && n) n.innerHTML = '<img src="' + esc(img(v.image, 80)) + '" alt="">';
    }
    function selectTier(i) {
      state.tier = i;
      $$('.vx-offer', offers).forEach(function (o) { var on = +o.getAttribute('data-tier') === i; o.classList.toggle('is-selected', on); $('input[type=radio]', o).checked = on; });
      updateAtc();
    }
    function tierItems() {
      var t = C.tiers[state.tier], items = [];
      if (C.mode === 'variant') {
        var v = data.variants[state.tier] || data.variants[0];
        items.push({ id: v.id, quantity: 1 });
      } else {
        var lab = $('.vx-offer[data-tier="' + state.tier + '"]', offers);
        var rows = $$('.vx-pick', lab);
        if (!rows.length) { items.push({ id: (state.variant || firstAvail()).id, quantity: t.q }); }
        rows.forEach(function (r) {
          var vals = opts.map(function () { return null; });
          $$('select', r).forEach(function (s) { vals[+s.getAttribute('data-oi')] = s.value; });
          var v = findVariant(vals);
          if (!v) throw new Error('Den kombinationen finns inte.');
          if (!v.available) throw new Error(v.options.join(' / ') + ' är slutsåld.');
          var ex = items.filter(function (x) { return x.id === v.id; })[0];
          if (ex) ex.quantity++; else items.push({ id: v.id, quantity: 1 });
        });
      }
      if (t.gift && giftId) items.push({ id: giftId, quantity: 1, properties: { _vx_gift: '1' } });
      return items;
    }
    function updateAtc() {
      if (!atcLbl) return;
      var base = atcLbl.getAttribute('data-base') || atcLbl.textContent;
      atcLbl.setAttribute('data-base', base);
      var price = null;
      if (C && C.tiers && state.tier != null) price = C.tiers[state.tier].total;
      else if (state.variant) price = state.variant.price;
      var v = state.variant;
      if (!C || !C.tiers) {
        atc.disabled = !(v && v.available);
        atcLbl.textContent = v && !v.available ? 'Slutsåld' : base + (price ? ' · ' + money(price) : '');
      } else atcLbl.textContent = base + ' · ' + money(price);
      var sp = $('[data-vx-sticky-price]'); if (sp) sp.textContent = money(price);
    }
    // plain option buttons (products without tiers)
    $$('.vx-opt input', el).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var vals = opts.map(function (o, i) { var c = $('.vx-opt[data-oi="' + i + '"] input:checked', el); return c ? c.value : null; });
        state.variant = findVariant(vals) || state.variant;
        $$('.vx-opt', el).forEach(function (f) { var c = $('input:checked', f), s = $('legend span', f); if (s && c) s.textContent = c.value; });
        var pe = $('[data-vx-price]', el); if (pe && state.variant) pe.textContent = money(state.variant.price);
        if (state.variant && state.variant.image) goToImage(el, state.variant.image);
        updateAtc();
      });
    });
    $$('.vx-qty', el).forEach(function (q) {
      q.addEventListener('click', function (e) { var b = e.target.closest('[data-q]'); if (!b) return; var i = $('input', q); i.value = Math.max(1, +i.value + +b.getAttribute('data-q')); });
    });
    buildOffers();
    updateAtc();
    if (atc) atc.addEventListener('click', function (e) {
      e.preventDefault();
      var items;
      try {
        if (C && C.tiers) items = tierItems();
        else { var q = $('.vx-qty input', el); items = [{ id: state.variant.id, quantity: q ? Math.max(1, +q.value) : 1 }]; }
      } catch (er) { if (msg) msg.textContent = er.message; return; }
      if (msg) msg.textContent = '';
      atc.classList.add('is-loading');
      add(items).catch(function (er) { if (msg) msg.textContent = er.message; else toast(er.message); }).then(function () { atc.classList.remove('is-loading'); });
    });
    // sticky
    var st = $('.vx-sticky');
    if (st && atc && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) seen = true; st.classList.toggle('is-on', !x.isIntersecting && (seen || x.boundingClientRect.top < 0)); }); }).observe(atc);
      var sb = $('button', st);
      if (sb) sb.addEventListener('click', function () { var tgt = offers || atc; window.scrollTo({ top: tgt.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }); });
    }
  }
  function goToImage(el, src) {
    var tr = $('.vx-gal__track', el.closest('.vx-pdp') || document); if (!tr) return;
    var base = src.split('?')[0].replace(/\.[a-z]+$/i, '').split('/').pop();
    $$('.vx-gal__slide img', tr).some(function (im, i) { if ((im.currentSrc || im.src).indexOf(base) > -1) { tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); return true; } });
  }
  $$('[data-vx-product]').forEach(initProduct);

  /* ---------- gallery ---------- */
  $$('.vx-gal').forEach(function (g) {
    var tr = $('.vx-gal__track', g), th = $$('.vx-gal__thumbs button', g), dots = $$('.vx-gal__dots i', g);
    function idx() { return Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); }
    function mark() { var i = idx(); th.forEach(function (b, k) { b.classList.toggle('is-on', k === i); }); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
    tr.addEventListener('scroll', function () { clearTimeout(tr._t); tr._t = setTimeout(mark, 60); }, { passive: true });
    th.forEach(function (b, k) { b.addEventListener('click', function () { tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }); });
    mark();
  });

  /* ---------- horizontal rows: arrows ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-vx-scroll]'); if (!a) return;
    var row = document.getElementById(a.getAttribute('aria-controls')); if (!row) return;
    row.scrollBy({ left: (+a.getAttribute('data-vx-scroll')) * row.clientWidth * 0.8, behavior: 'smooth' });
  });

  fillPh(document);
  (function () { // "Skickas senast <date>": next business day, Swedish short date
    var d = new Date(); d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    var m = ['jan', 'feb', 'mars', 'apr', 'maj', 'juni', 'juli', 'aug', 'sep', 'okt', 'nov', 'dec'];
    $$('[data-vx-shipdate]').forEach(function (el) { el.textContent = d.getDate() + ' ' + m[d.getMonth()]; });
  })();
  $$('[data-vx-cmp]').forEach(function (el) { var c = cfg(el.getAttribute('data-vx-cmp')), u = +el.getAttribute('data-unit'); if (c && c.compare > u) { el.textContent = money(c.compare); var p = el.previousElementSibling; if (p) p.classList.add('vx-price--sale'); } });
})();
